import { EntitlementSyncFailureClassEnum } from '../enums/entitlement-sync-failure-class.enum';

/**
 * Upsert a fingerprinted entitlement sync failure (DLQ).
 */
export class EntitlementSyncFailureUpsertRequest {
  fingerprint!: string;
  tenantId?: number | null;
  meteringProviderCustomerId?: string | null;
  code!: string;
  failureClass!: EntitlementSyncFailureClassEnum;
  message!: string;
  details?: Record<string, unknown> | null;
}
